// main.js — Punto de entrada JavaScript
console.log('MiProyecto cargado correctamente');

//# sourceMappingURL=ProyectoFinal.f77e8c8b.js.map
